/* eslint-disable import/no-cycle */
import Parent from '../views/Parent.vue';

import ListMerchant from '../views/merchant-management/ListMerchant.vue';
import DetailMerchant from '../views/merchant-management/DetailMerchant.vue';

import { setBreadcrumb } from './index';

const merchantManagementRoute = {
  path: '/merchant-management',
  meta: {
    title: 'BNI QRIS - Merchant Management',
    appBarTitle: 'Merchant Management',
  },
  component: Parent,
  children: [
    {
      path: '',
      name: 'ListMerchant',
      meta: {
        title: 'BNI QRIS - Merchant Management',
        appBarTitle: 'Merchant Management',
        breadcrumbs: () => [
          setBreadcrumb('merchant management', '/merchant-management', true),
          setBreadcrumb('list merchant', '/merchant-management'),
        ],
      },
      component: ListMerchant,
    },
    {
      path: '/merchant-management/:id(\\d+)',
      meta: {
        title: 'BNI QRIS - Merchant Detail',
        appBarTitle: 'Merchant Detail',
        breadcrumbs: (params) => {
          const { id } = params;
          return [
            setBreadcrumb('merchant management', '/merchant-management', true),
            setBreadcrumb('list merchant', '/merchant-management'),
            setBreadcrumb(
              `detail merchant ${id}`,
              `/merchant-management/${id}`
            ),
          ];
        },
      },
      component: DetailMerchant,
      name: 'DetailMerchant',
    },
  ],
};
export default merchantManagementRoute;
